import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../StoreMenu";
import { getStoreInvoicePrinter, getStoreLocalData, getUserData } from "../../utils/localStorage";
import {
  formatDate,
  formatDateReceipt,
  formatDateWithTime,
} from "../../constants/DateUtil/DateUtil";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";
import AdminMenu from "../AdminMenu";

const WalletCollectionReceipt = () => {
  const { storeData, brandProfileData, userProfileData, userProfileRole } = getUserData();

  let store = storeData;
  let brand = brandProfileData;
  const userProfile = userProfileData;
  const userRole = userProfileRole;

  const { storeLocalData } = getStoreLocalData();

  const location = useLocation();
  const { walletCollectionData, orderFilterData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const startDate = new Date(
    Math.min(...walletCollectionData.map((item) => new Date(item.createdDate)))
  ).toISOString();

  const endDate = new Date(
    Math.max(...walletCollectionData.map((item) => new Date(item.createdDate)))
  ).toISOString();

  const data = {
    storeName: store.storeName,
    brandName: brand.name,
    receivedBy: userProfile.firstName + " " + userProfile.lastName,
  };

  const totalCollectionData = walletCollectionData.reduce(
    (acc, item) => acc + item.payment.amount,
    0
  );

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  useEffect(() => {
    if (!isConnected) {
      connectToQZ();
    }

    fetchSelectedInvoicePrinter();
  }, []);

  const printInvoiceHTML = async () => {
    try {
      const printer = await qz.printers.find(invoicePrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });
  
      const walletCollectionHtml = walletCollectionData
        .map((item) => {
          const date = formatDateReceipt(item.payment.date)
          const customerData = item.storeCustomerAccount.storeCustomer.brandCustomer
            .firstName +
            ' ' +
            item.storeCustomerAccount.storeCustomer.brandCustomer
              .lastName;
          const mobile = 
            item.storeCustomerAccount.storeCustomer.brandCustomer
              .mobile;
          const paymentAmount = item.payment.amount;
  
          return `
            <div style="display: flex;">
              <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${date}</p>
              <p style="flex: 2; font-size: 12px; margin: 0; text-align: left;">${customerData}</p>
              <p style="flex: 1; font-size: 12px; margin: 0; text-align: right;">${mobile}</p>
              <p style="flex: 1; font-size: 12px; margin: 0; text-align: right;">${storeLocalData?.currencySymbol} ${paymentAmount}</p>
            </div>
          `;
        })
        .join("");
  
      const htmlContent = `
        <html>
          <body style="font-size: 12px; font-family: sans-serif;">
            <div style="text-align: center;">
              <span style="font-size: 18px; font-weight: bold;">Payment Collection</span>
              <hr style="border-top: 1px dashed #000;"/>
              <p style="font-size: 14px; font-weight: bold; margin: 0;">${userRole === 'BY_ADMIN' || userRole === "BY_SUB_ADMIN_USER" ? data.brandName : data.storeName}</p>
              <p style="font-size: 12px; margin: 0;">Period - ${formatDate(startDate)} - ${formatDate(endDate)}</p>
              <hr style="border-top: 1px dashed #000;"/>
              <div style="display: flex;">
                <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Date</p>
                <p style="flex: 1.5; font-weight: bold; margin: 0; text-align: left;">Customer</p>
                <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Mobile</p>
                <p style="flex: 1; font-weight: bold; margin: 0; text-align: right;">Amt</p>
              </div>
              ${walletCollectionHtml}
              <hr style="border-top: 1px dashed #000;"/>
              <div style="display: flex; justify-content: space-between;">
                <span><strong>Total:</strong></span>
                <span>${storeLocalData?.currencySymbol} ${totalCollectionData}</span>
              </div>
              <hr style="border-top: 1px dashed #000;"/>
              <p style="font-size: 12px; margin: 0;">${formatDateWithTime(new Date())}</p>
            </div>
          </body>
        </html>
      `;
  
      await qz.print(config, [{ type: "html", format: "plain", data: htmlContent }]);
      // alert("HTML challan sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print challan");
    }
  };
  

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/WalletCollection", {
                      state: {
                        orderFilterData: orderFilterData,
                        // customerData: customerData,
                        // storeCustomerId: storeCustomerId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Wallet Collection
              </p>
            </div>
            <div className="flex">
              <div className="mx-4 cursor-pointer" onClick={printInvoiceHTML}>
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex justify-content-between mt-2 ">
        <div></div>
        <div className="flex justify-content-center flex-column print-section">
          <p className="text-3xl font-medium text-center">Wallet Collection</p>
          <div className="flex justify-content-center align-items-center">
            <p className="w-7  border-dashed border-1 "></p>
          </div>
          <p className="text-xl font-medium text-center">
            {userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
              ? data.brandName
              : data.storeName}
          </p>
          <p className="text-md font-medium text-center">
            Period - {formatDate(startDate)} - {formatDate(endDate)}
          </p>
          <div className="flex justify-content-center align-items-center">
            <p className="w-5  border-dashed border-1 "></p>
          </div>

          <div className="flex">
            <p
              className="text-sm font-medium text-left mx-2"
              style={{ flex: 1.3 }}
            >
              Date
            </p>
            <p
              className="text-sm font-medium text-left mx-2"
              style={{ flex: 2 }}
            >
              Customer
            </p>
            <p
              className="text-sm font-medium text-left ml-4"
              style={{ flex: 2 }}
            >
              Mobile
            </p>
            <p
              className="text-sm font-medium text-left mr-2"
              style={{ flex: 1 }}
            >
              Amt
            </p>
          </div>
          {walletCollectionData.map((item, index) => {
            const customerFirstName = item.storeCustomerAccount.storeCustomer
              .brandCustomer.firstName
              ? item.storeCustomerAccount.storeCustomer.brandCustomer.firstName
              : "";
            const customerLastName = item.storeCustomerAccount.storeCustomer
              .brandCustomer.lastName
              ? item.storeCustomerAccount.storeCustomer.brandCustomer.lastName
              : "";
            return (
              <div className="flex " key={index}>
                <p
                  className="text-sm font-normal text-left mx-1"
                  style={{ flex: 1.2 }}
                >
                  {formatDateReceipt(item.payment.date)}
                </p>
                <p
                  className="text-sm font-normal text-left  mx-1"
                  style={{ flex: 2 }}
                >
                  {customerFirstName + " " + customerLastName}
                </p>
                <p
                  className="text-sm font-normal text-right  mx-1"
                  style={{ flex: 1 }}
                >
                  {item.storeCustomerAccount.storeCustomer.brandCustomer.mobile}
                </p>
                <p
                  className="text-sm font-normal text-right  mx-1"
                  style={{ flex: 1 }}
                >
                  {storeLocalData?.currencySymbol}{item.payment.amount}
                </p>
              </div>
            );
          })}

          <div className="flex ">
            <p className="text-lg font-medium text-left" style={{ flex: 2 }}>
              Total :
            </p>
            <p
              className="text-lg font-medium text-left"
              style={{ flex: 1 }}
            ></p>
            <p className="text-lg font-medium text-right" style={{ flex: 1 }}>
              {storeLocalData?.currencySymbol} {totalCollectionData}
            </p>
          </div>
          <div className="flex justify-content-center align-items-center">
            <p className="w-5  border-dashed border-1 "></p>
          </div>
          <p className="text-lg font-medium text-center">
            {formatDateWithTime(new Date())}
          </p>
          <div className="flex justify-content-center align-items-center">
            <p className="w-7  border-dashed border-1 "></p>
          </div>
        </div>

        <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
          <img
            src={"Icons/printer.png"}
            style={{
              width: 60,
            }}
          />
        </div>
      </div>
      {/* Menu component */}
      {userRole === "BY_ADMIN" ||
      userRole === "BY_SUB_ADMIN_USER" ||
      userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
            @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default WalletCollectionReceipt;
